export const isEmptyArray = (value: any) => Array.isArray(value) && !value.length;
